<template>
  <div>
    <v-row>
      <v-col cols="12 py-0">
        <ValidationObserver ref="observer">
          <v-card>
            <v-container fluid>
        
              <v-row class="ma-0 align-left">
                <v-col
                  cols="12"
                  sm="6"
                  lg="6"
                  md="6"
                  class="px-0 d-flex justify-space-between"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Category"
                    rules="required"
                  >
                    <treeselect
                      outlined
                      :error-messages="errors"
                      required
                      class="tree-border"
                      dense
                       
                      v-model="categoryId"
                      filled
                      :options="categories"
                      placeholder="Category"
                      @select="onSelectCategory"
                    >
                      <label
                        slot="option-label"
                        slot-scope="{
                          node,
                          shouldShowCount,
                          count,
                          labelClassName,
                          countClassName,
                        }"
                        :class="labelClassName"
                      >
                        {{ node.raw.label }}
                        <span v-if="shouldShowCount" :class="countClassName"
                          >({{ count }})</span
                        >
                      </label>
                    </treeselect>
                    <span class="error-message" v-if="categoryError != ''">
                      {{ categoryError }}</span
                    >
                  </ValidationProvider>

                  <v-btn
                    depressed
                    small
                    height="32"
                    class="btn_blue w-100 ml-2"
                    @click="submit"
                   
                  >
                 
                    update
                     <v-icon  >mdi-arrow-right-bold</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </ValidationObserver>
      </v-col>
    </v-row>
  
  </div>
</template>
<script>
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  data: () => ({
    categories: [],
    categoryId: null,
    GetDatsCategory :"",
    searchCategory: null,
    categoryError: "",
  }),
  components: {
    ValidationProvider,
    ValidationObserver,
    Treeselect
  },
 props: {
    DishCategory: {
      type: Array,
      default: [],
    },
   
  },

  created() {
    this.categoryId = this.DishCategory;
    this.GetProductCategoriesByQuery();
  },
  methods: {
    GetDatas() {
     return this.categoryId;
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid && this.categoryId) {
        this.$emit("save", [Number(this.categoryId)]);
      }
    },
    


    GetProductCategoriesByQuery(query = "") {
      
      this.$store
        .dispatch("product/GetProductCategoriesWithChild", {
          query: query.searchQuery,
        })
        .then((res) => {
          console.log(res);
          this.categories = res.data;
        })
        .catch((err) => {});
    },
  },
};
</script>
